import React from "react";
import "./BuyerQC.css";

import Pagination from "@mui/material/Pagination";
import { LuClipboardCopy } from "react-icons/lu";
import toast, { Toaster } from "react-hot-toast";
import { FaEye } from "react-icons/fa";
import { copyTextToClipboard } from "../../utils/helper";
import Modal from "react-bootstrap/Modal";
import ReactJson from "react-json-view";
import QCFilter from "../../components/QCFilter/StoreQCFilter";
import { Tabs, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import useBuyerQC from "../../customHooks/QC/useBuyerQC";
import BuyerQCFilter from "../../components/QCFilter/BuyerQCFilter";

const BuyerQC = () => {
  const {
    data,
    currentPage,
    loader,
    totalCount,
    pageSize,
    handleInputPageChange,
    handlePageChange,
    handlePageSize,
    jsonBody,
    setJsonBody,
    setOpenJson,
    openJson,
    remarkBody,
    setremarkBody,
    openRemark,
    setOpenRemark,
    variantId,
    setVariantId,
    
    category,
    setCategory,
    title,
    setTitle,
    issueType,
    setIssueType,
    buyerApp,
    setBuyerApp,
    issueTypes,
    setIssueTypes,
    buyerApps,
    setBuyerApps,
    createdAt,
    setCreatedAt,
    activeTab,
    setActiveTab,
    key,
    setKey,
  } = useBuyerQC();
  return (
    <>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          success: {
            duration: 1500,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
      <div className="mainDiv">
        <div className="screenRoot">
          <div className="screenTitleSections">
            <div className="screenTitle">QC</div>
          </div>
        </div>
        <div className="col d-flex">
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            // onSelect={(k) => setKey(k)}
          >
            <Tab
              eventKey="storeqc"
              title={
                <Link to="/storeqc" className="nav-link">
                  Store QC
                </Link>
              }
            >
              <div></div>
            </Tab>
            <Tab
              eventKey="buyerappqc"
              title={
                <Link to="/buyerappqc" className="nav-link">
                  Buyer App QC
                </Link>
              }
            >
              <div></div>
            </Tab>
          </Tabs>
        </div>
        <div className="screenBodyRoot">
          <div className="screenTableFeaturesRoot">
            <BuyerQCFilter
              variantId={variantId}
              setVariantId={setVariantId}

              category={category}
              setCategory={setCategory}
              title={title}
              setTitle={setTitle}
              issueType={issueType}
              setIssueType={setIssueType}
              buyerApp={buyerApp}
              setBuyerApp={setBuyerApp}
              issueTypes={issueTypes}
              setIssueTypes={setIssueTypes}
            
              createdAt={createdAt}
              setCreatedAt={setCreatedAt}
            />
          </div>
          <div className="row d-flex justify-content-between mt-3">
            <div className="col-2 mt-2">
              Showing{" "}
              {data && data.length
                ? `${(currentPage - 1) * pageSize + 1} -
                  ${(currentPage - 1) * pageSize + data.length}`
                : 0}{" "}
              of {totalCount || 0}
            </div>
            <div className="col-2 d-flex justify-content-center align-items-center pb-1">
              <label className="formLabels mx-2">Go&nbsp;to&nbsp;Page</label>
              <input
                type="text"
                value={currentPage || ""}
                id="currentPage"
                name="currentPage"
                onChange={handleInputPageChange}
                placeholder="Search page number"
                className="form-control"
              />
            </div>
          </div>
          {!loader ? (
            <>
              <div className="screenTableRecordsRoot logScreenRoot">
                <div className="table-responsive ">
                  <div className="table-responsive">
                    <table className="table table-bordered align-middle table-striped">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "10%" }}>Category</th>
                          <th style={{ width: "15%" }}>Title</th>
                          <th style={{ width: "15%" }}>Buyer App</th>
                          <th style={{ width: "15%" }}>Variant ID</th>
                          <th style={{ width: "10%" }}>Issue Type</th>
                          <th style={{ width: "10%" }}>Created At</th>
                          <th style={{ width: "12%" }}>Remark</th>
                          <th style={{ width: "13%" }}>Attributes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data && data.length > 0 ? (
                          data.map((qc, index) => (
                            <tr key={index}>
                              <td>{qc.category}</td>
                              <td>{qc.title}</td>
                              <td style={{ wordBreak: "break-word" }}>
                                {qc.buyerApp}
                              </td>
                              <td style={{ wordBreak: "break-word" }}>
                                {qc.variantId}
                              </td>
                              <td>{qc.issueType}</td>
                              <td>
                                {new Date(qc.createdAt)
                                  .toString()
                                  .split(" ")
                                  .slice(0, 5)
                                  .join(" ")}
                              </td>
                              <td>
                                {qc.remark ? (
                                  <div className="itemBody p-2">
                                    {JSON.stringify(qc.remark, null, 2)}
                                    <span
                                      className="copy-btn-json"
                                      onClick={() => {
                                        toast.success("Copied");
                                        copyTextToClipboard(qc.remark, null, 2);
                                      }}
                                    >
                                      <LuClipboardCopy size={20} />
                                    </span>
                                    <span
                                      className="show-more-btn"
                                      onClick={() => {
                                        setremarkBody(qc.remark);
                                        setOpenRemark(true);
                                      }}
                                    >
                                      <FaEye size={15} /> &nbsp;View
                                    </span>
                                  </div>
                                ) : (
                                  <>-</>
                                )}
                              </td>
                              <td>
                                <div className="itemBody p-2">
                                  {JSON.stringify(qc.options, null, 2)}
                                  <span
                                    className="copy-btn-json"
                                    onClick={() => {
                                      toast.success("Copied");
                                      copyTextToClipboard(
                                        JSON.stringify(qc.options, null, 2)
                                      );
                                    }}
                                  >
                                    <LuClipboardCopy size={20} />
                                  </span>
                                  <span
                                    className="show-more-btn"
                                    onClick={() => {
                                      setJsonBody(qc.options);
                                      setOpenJson(true);
                                    }}
                                  >
                                    <FaEye size={15} /> &nbsp;View
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={8} className="text-center">
                              No data found!
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {totalCount > pageSize ? (
                <div className="screenTablePaginationRoot">
                  <Pagination
                    // component="div"
                    count={Math.ceil(totalCount / pageSize)}
                    page={currentPage}
                    onChange={handlePageChange}
                    // rowsPerPage={pageSize}
                    // onRowsPerPageChange={handlePageSize}
                  />
                </div>
              ) : null}
            </>
          ) : (
            <div className="screenTableRootLoader">{/* <SmallLoader /> */}</div>
          )}
        </div>
      </div>
      <Modal
        show={openJson}
        onHide={() => setOpenJson(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="json-body">
            <ReactJson src={jsonBody} />
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer> */}
      </Modal>
      <Modal
        show={openRemark}
        onHide={() => setOpenRemark(false)}
        centered
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>Remarks</Modal.Header>
        <Modal.Body>
          <div>{remarkBody}</div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default BuyerQC;
